/* eslint @typescript-eslint/no-explicit-any: "off" */
import React from "react";
import { I18n } from "@aws-amplify/core";
import { ConfirmSignIn } from "aws-amplify-react";
import { Button, Link, TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";

import { AuthWrapper, styles } from "./AuthWrapper";

/**
 * The per-login code prompt, shown once a user with a registered authenticator
 * has entered a correct password.
 *
 * Replaces the stock ConfirmSignIn, which renders unstyled aws-amplify-react
 * markup -- the Amplify UI stylesheet is not loaded in this app.
 */
class CustomConfirmSignIn extends ConfirmSignIn {
  authToastMessage: string;

  constructor(props: any) {
    super(props);
    this._validAuthStates = ["confirmSignIn"];
    this.authToastMessage = "";
  }

  /***
   * Same approach as CustomSignIn: capture the error for inline display and
   * suppress the default Toast by passing showToast = false.
   *
   * Unlike the sign-in screen, the message is NOT masked. There, a vague error
   * avoids confirming whether a username exists. Here the password has already
   * been accepted, so naming the real problem gives an attacker nothing and
   * saves the user a support call -- an expired code is the common case, since
   * codes roll every 30 seconds.
   */
  triggerAuthEvent(event: any) {
    if (event.type === "error") {
      this.authToastMessage = I18n.get(
        "That code was not accepted. Codes change every 30 seconds — wait for your authenticator app to show a new one and try again."
      );
    }

    const state = this.props.authState;
    if (this.props.onAuthEvent) {
      this.props.onAuthEvent(state, event, false);
    }
  }

  showComponent() {
    const classesProps: any = this.props;
    const classes: any = classesProps.classes;

    return (
      <AuthWrapper
        title={I18n.get("Admin Login")}
        subtitle={I18n.get("Enter the code from your authenticator app")}
      >
        <TextField
          required
          autoFocus={true}
          id="code"
          key="code"
          name="code"
          label={I18n.get("Six-digit code")}
          autoComplete="off"
          inputProps={{ inputMode: "numeric", maxLength: 6 }}
          onChange={this.handleInputChange}
        />

        <Button
          className={classes.button}
          variant="contained"
          color="primary"
          onClick={this.confirm}
          type="submit"
        >
          {I18n.get("Sign In")}
        </Button>

        <Link onClick={() => this.changeState("signIn")}>
          {I18n.get("Back to Sign In")}
        </Link>

        {this.authToastMessage && (
          <Alert variant="outlined" severity="error">
            {this.authToastMessage}
          </Alert>
        )}
      </AuthWrapper>
    );
  }
}

export default withStyles(styles)(CustomConfirmSignIn);
